export const CANCELLED_ROUTE_ERROR_MESSAGE = "Cancel rendering route";

// set by the marketing site or the checkout
export const USE_CASE_QUERY_PARAM = "use_case";

// ad platforms click ids (Google, LinkedIn, Reddit, Microsoft, OpenAI)
export const CLICK_ID_QUERY_PARAMS = [
  "gclid",
  "wbraid",
  "gbraid",
  "li_fat_id",
  "rdt_cid",
  "msclkid",
  "oppref",
] as const;

// Query keys that may follow a post-login / post-checkout redirect. Anything
// else stays on the current page so leftover `router.query` cannot taint the
// URL we push (UTM/GCLID are copied separately from the router).
export const REDIRECT_QUERY_PARAM_ALLOWLIST = [
  "plan",
  "ai",
  "migration-id",
  "migration-source-plan",
] as const;
